import { useRouter, useRouterState } from "@tanstack/react-router";
import { pathWithinTenant } from "../tenant-paths.ts";

// The router basepath is "/<slug>"; the slug is "" for the root-level router.
export const slugFromBasepath = (basepath: string): string => basepath.replace(/^\/+|\/+$/g, "");

// TanStack's location.pathname includes the basepath; this is the path below it, comparable to un-prefixed hrefs.
export const stripBasepath = (pathname: string, basepath: string): string => {
  const slug = slugFromBasepath(basepath);
  return slug === "" ? pathname : pathWithinTenant(pathname, slug);
};

export const useTenantSlug = (): string => slugFromBasepath(useRouter().basepath);

export const useAppPathname = (): string => {
  const basepath = useRouter().basepath;
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  return stripBasepath(pathname, basepath);
};
